import {
  Columns,
  TextCircle,
} from '@energybox/react-ui-library/dist/components';
import { pluralize } from '@energybox/react-ui-library/dist/utils/util';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link, withRouter } from 'react-router-dom';

interface ListItem {
  title: string;
  displayTitle: string;
  linkTo?: string;
}

interface Props extends RouteComponentProps {
  history: any;
  limit?: number;
  resource: string;
  items: ListItem[];
  moreButtonLinkTo?: string;
  disableResourceLink?: boolean;
}

interface MoreButtonProps {
  resource: string;
  count: number;
  limit: number;
  linkTo?: string;
  disableResourceLink?: boolean;
}

const MoreButton = ({
  resource,
  count,
  limit,
  linkTo = '#',
  disableResourceLink = false,
}: MoreButtonProps) => {
  if (count === 0) {
    return <span>0 users</span>;
  } else if (count <= limit) {
    return disableResourceLink ? (
      <span>
        {count} {pluralize(resource, count)}
      </span>
    ) : (
      <Link to={linkTo}>
        {count} {pluralize(resource, count)}
      </Link>
    );
  } else {
    return disableResourceLink ? (
      <span>
        +{count - limit} {pluralize(resource, count - limit)}
      </span>
    ) : (
      <Link to={linkTo}>
        +{count - limit} {pluralize(resource, count - limit)}
      </Link>
    );
  }
};

const BubblesList = ({
  history,
  resource,
  limit = 10,
  items,
  moreButtonLinkTo,
  disableResourceLink = false,
}: Props) => (
  <Columns template={`${22 * limit}px auto`}>
    <div>
      {items
        .map(({ title, displayTitle, linkTo }: ListItem) => (
          <TextCircle
            key={title}
            onClick={() => linkTo && history.push(linkTo)}
            title={title}
            children={displayTitle}
          />
        ))
        .slice(0, limit)}
    </div>

    <div style={{ display: 'flex', alignItems: 'center' }}>
      <MoreButton
        resource={resource}
        count={items.length}
        limit={limit}
        linkTo={moreButtonLinkTo}
        disableResourceLink={disableResourceLink}
      />
    </div>
  </Columns>
);

export default withRouter(BubblesList);
